export default {
  "common": {
    "appName": "CleanFlow",
    "confirm": "确定",
    "cancel": "取消",
    "save": "保存",
    "add": "添加",
    "delete": "删除",
    "edit": "编辑",
    "back": "返回",
    "close": "关闭",
    "loading": "加载中…",
    "submitting": "提交中…",
    "saving": "保存中…",
    "retry": "重试",
    "language": "语言",
    "logout": "退出登录",
    "optional": "选填",
    "copy": "复制",
    "copied": "已复制",
    "saved": "已保存",
    "archive": "归档",
    "restore": "恢复",
    "disable": "停用",
    "enable": "启用",
    "networkError": "网络连接失败，请检查网络后重试",
    "unknownError": "出了点问题，请稍后再试"
  },
  "auth": {
    "loginTitle": "登录",
    "loginSubtitle": "民宿清扫派工系统",
    "orgCode": "组织代码",
    "orgCodePlaceholder": "老板登录必填，管理员可留空",
    "registerSuccessWithCode": "注册成功！请记住组织代码：{code}",
    "orgCodeHint": "老板/员工登录必填；平台管理员请留空",
    "username": "账号",
    "usernamePlaceholder": "请输入账号",
    "usernameHint": "字母、数字或手机号，3–64 位",
    "password": "密码",
    "passwordPlaceholder": "请输入密码",
    "loginButton": "登录",
    "loggingIn": "登录中…",
    "goRegister": "注册组织",
    "registerTitle": "注册组织",
    "registerSubtitle": "创建组织并成为管理员",
    "orgName": "组织名称",
    "displayName": "姓名",
    "locale": "显示语言",
    "contactPhoneOptional": "电话（选填）",
    "registerSubmit": "注册并开始使用",
    "backToLogin": "返回登录",
    "changePasswordTitle": "修改密码",
    "changePasswordForced": "这是你第一次登录，请先设置一个自己的密码",
    "currentPassword": "当前密码",
    "newPassword": "新密码",
    "confirmPassword": "确认新密码",
    "passwordMinLength": "密码至少 8 位",
    "passwordMismatch": "两次输入的新密码不一致",
    "changePasswordSuccess": "密码修改成功"
  },
  "role": {
    "PLATFORM_ADMIN": "平台管理员",
    "OWNER": "老板",
    "STAFF": "员工"
  },
  "nav": {
    "calendar": "清扫日历",
    "review": "待审核",
    "biz": "经营",
    "tasks": "我的任务",
    "records": "清扫记录",
    "finance": "经营结算",
    "payroll": "我的收入",
    "settings": "设置"
  },
  "status": {
    "archived": "已归档",
    "disabled": "已停用"
  },
  "settings": {
    "title": "设置",
    "masterData": "基础数据",
    "clients": "委托方管理",
    "buildings": "楼栋管理",
    "rooms": "房间与价格",
    "staff": "员工管理",
    "account": "账号",
    "changePassword": "修改密码",
    "orgLoginCode": "组织代码",
    "orgLoginCodeHint": "",
    "about": "关于",
    "version": "版本",
    "logoutTitle": "退出登录？",
    "logoutMessage": "退出后需要重新输入账号和密码。已经录入的数据不会丢失。",
    "operations": "运营设置"
  },
  "client": {
    "title": "委托方",
    "newTitle": "新建委托方",
    "editTitle": "编辑委托方",
    "empty": "还没有委托方",
    "emptyHint": "委托方是把房子交给你打理的一方，也是月底对账的对象",
    "total": "共 {count} 个",
    "name": "名称",
    "namePlaceholder": "例如：山田管理",
    "nameHint": "同一个名称不能重复",
    "nameRequired": "请填写名称",
    "contactName": "对接人",
    "contactPhone": "联系电话",
    "postalCode": "请求书邮编",
    "address": "请求书地址",
    "addressHint": "印在请求书「御中」下面。不填就只写名称",
    "note": "备注",
    "notePlaceholder": "例如：每月 25 日结算",
    "summary": "{buildings}栋 {rooms}间",
    "archiveTitle": "归档这个委托方？",
    "archiveMessage": "归档后它名下的楼栋不会再出现在派工的选择列表里，历史记录照常保留。",
    "restoreTitle": "恢复这个委托方？",
    "restoreMessage": "恢复后它名下启用中的楼栋可以重新派工。",
    "deleteTitle": "删除这个委托方？",
    "deleteMessage": "这条记录会被彻底删除，无法恢复。",
    "deleteBlocked": "名下已有楼栋，只能归档"
  },
  "building": {
    "title": "楼栋",
    "newTitle": "新建楼栋",
    "editTitle": "编辑楼栋",
    "empty": "还没有楼栋",
    "emptyHint": "一户建也当作一栋来建，下面放一个房间就行",
    "emptyFiltered": "这个委托方名下还没有楼栋",
    "total": "共 {count} 栋",
    "allClients": "全部委托方",
    "client": "所属委托方",
    "clientLocked": "建好后不能更换委托方",
    "clientRequired": "请选择委托方",
    "name": "楼栋名",
    "namePlaceholder": "例如：A栋、一户建A",
    "nameHint": "同一委托方下不能重复，不同委托方可以同名",
    "nameRequired": "请填写楼栋名",
    "address": "地址",
    "addressPlaceholder": "员工找路用",
    "note": "备注",
    "notePlaceholder": "例如：钥匙箱密码、垃圾投放规则",
    "sortOrder": "排序",
    "sortOrderHint": "数字小的排在前面",
    "roomCount": "{count}间",
    "noClientYet": "请先创建委托方",
    "noClientYetHint": "楼栋必须挂在某个委托方名下",
    "goCreateClient": "去创建委托方",
    "archiveTitle": "归档这处楼栋？",
    "archiveMessage": "归档后它不会再出现在派工的选择列表里，历史记录照常保留。",
    "restoreTitle": "恢复这处楼栋？",
    "restoreMessage": "恢复后可以重新派工。",
    "deleteTitle": "删除这处楼栋？",
    "deleteMessage": "这条记录会被彻底删除，无法恢复。",
    "deleteBlocked": "名下已有房间，只能归档"
  },
  "room": {
    "title": "房间与价格",
    "newTitle": "新建房间",
    "editTitle": "编辑房间",
    "empty": "这处楼栋还没有房间",
    "emptyHint": "房间要同时设定「向委托方收多少」和「付给员工多少」",
    "total": "共 {count} 间",
    "allBuildings": "全部楼栋",
    "building": "所属楼栋",
    "buildingLocked": "建好后不能更换所属楼栋",
    "buildingRequired": "请选择所属楼栋",
    "name": "房号",
    "namePlaceholder": "例如：101",
    "nameHint": "同一楼栋内不能重复",
    "nameRequired": "请填写房号",
    "clientPrice": "向委托方收",
    "staffBasePay": "付给员工（基础）",
    "staffBasePayHint": "可以再针对某个员工单独调整",
    "priceRequired": "请填写金额",
    "grossMargin": "每单毛利",
    "marginNegative": "这个价格是亏本的，确认无误再保存",
    "note": "备注",
    "notePlaceholder": "例如：双床房、有沙发床",
    "sortOrder": "排序",
    "priceSummary": "收{client}　付{staff}",
    "noBuildingYet": "请先创建楼栋",
    "noBuildingYetHint": "房间必须挂在某处楼栋下面",
    "goCreateBuilding": "去创建楼栋",
    "suspended": "已停用",
    "archiveTitle": "停用这个房间？",
    "archiveMessage": "停用后它不会再出现在新建清扫任务的选择列表里，历史记录照常保留。",
    "restoreTitle": "重新启用这个房间？",
    "restoreMessage": "启用后可以重新派工。",
    "noDeleteHint": "房间只能停用，不能删除——历史清扫记录还要指向它"
  },
  "staff": {
    "title": "员工",
    "newTitle": "新建员工账号",
    "editTitle": "编辑员工",
    "detailTitle": "员工详情",
    "empty": "还没有员工",
    "emptyHint": "创建账号后把初始密码交给员工，他首次登录时需要自己改掉",
    "total": "共 {count} 人",
    "username": "登录名",
    "usernamePlaceholder": "例如：tanaka",
    "usernameHint": "字母、数字或手机号均可，3–64 位。建好后不能改",
    "usernameInvalid": "请使用字母、数字或手机号，3–64 位",
    "usernameLocked": "登录名建好后不能改",
    "displayName": "姓名",
    "displayNamePlaceholder": "派工界面上显示的名字",
    "displayNameRequired": "请填写姓名",
    "passwordAutoHint": "初始密码固定为 12345，员工可自行决定是否修改。",
    "noDeleteHint": "员工只能停用，不能删除——历史清扫记录和工资明细还要指向他",
    "phone": "手机号",
    "status": "状态",
    "active": "启用中",
    "notActivated": "未激活",
    "notActivatedHint": "仍在使用初始密码",
    "lastLogin": "最后登录",
    "neverLoggedIn": "从未登录",
    "adjustedCount": "{count}处调价",
    "roomRates": "房间工资设置",
    "credentialTitle": "账号已创建",
    "credentialResetTitle": "密码已重置",
    "credentialHint": "请立刻把这串密码告诉员工。关闭后无法再次查看，忘了只能重置。",
    "credentialOrgCode": "组织代码",
    "credentialUsername": "登录名",
    "credentialPassword": "初始密码",
    "credentialDone": "我已记下",
    "resetPassword": "重置密码",
    "resetTitle": "重置这个员工的密码？",
    "resetMessage": "密码将恢复为初始值 12345，当前密码立即失效。",
    "disableTitle": "停用这个员工？",
    "disableMessage": "停用后他立刻无法登录，历史清扫记录和工资明细全部保留。",
    "enableTitle": "重新启用这个员工？",
    "enableMessage": "启用后他可以用原来的账号密码登录。"
  },
  "rate": {
    "title": "{name} 的房间工资",
    "intro": "只有调整过的房间才单独记录，其余按房间默认工资。多人合扫的任务不使用这里的调价。",
    "adjustedInBuilding": "{count}处调整",
    "noAdjustment": "无调整",
    "totalAdjusted": "共 {count} 处调整",
    "resetAll": "全部恢复默认",
    "resetAllTitle": "恢复全部默认工资？",
    "resetAllMessage": "将清除这个员工的 {count} 处调价，之后全部按房间默认工资计算。此操作无法撤销。",
    "editTitle": "{room} 的工资",
    "payAmount": "这个员工的工资",
    "payRequired": "请填写工资金额",
    "defaultIs": "房间默认 {amount}",
    "note": "调价原因",
    "notePlaceholder": "例如：熟手，给高一点",
    "noteHint": "几个月后回头看，你会需要它",
    "restoreDefault": "恢复默认",
    "overriddenFrom": "默认 {default} → ",
    "emptyRooms": "还没有房间",
    "emptyRoomsHint": "先在「房间与价格」里创建房间"
  },
  "calendar": {
    "title": "清扫日历",
    "today": "今天",
    "totalOfDay": "共 {count} 项",
    "empty": "这一天没有清扫安排",
    "emptyHint": "点右下角的按钮登记一条",
    "groupCount": "{count} 项",
    "unassigned": "未分配",
    "sameDayCheckin": "当天入住",
    "stayGuests": "{count}人",
    "stayNights": "{count}晚",
    "sofaBed": "需铺沙发床",
    "sharedBy": "{count}人合扫",
    "weekdays": [
      "日",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六"
    ],
    "monthLabel": "{year}年{month}月",
    "monthShort": "{year}/{month}"
  },
  "task": {
    "newTitle": "清扫登记",
    "editTitle": "编辑清扫",
    "date": "日期",
    "building": "楼栋",
    "pickBuildingFirst": "请先选择楼栋",
    "buildingPlaceholder": "请选择楼栋",
    "room": "房间",
    "roomPlaceholder": "请选择房间",
    "roomFixed": "已登记的房间（不可改；仅可编辑备注）",
    "roomRequired": "请选择房间",
    "basePayHint": "该房间基础工资 {amount}",
    "alreadyRegistered": "今天已登记",
    "alreadyRegisteredHint": "这间房今天已经有清扫安排了，确认要再建一条吗",
    "workKind": "这一单做什么",
    "workKindCleaning": "清扫",
    "workKindOther": "其它事项",
    "workKindHint": "房间不用扫、但要办别的事时选其它事项，会进工资和请求书",
    "workLabel": "事项说明",
    "workLabelPlaceholder": "例如：换滤网、补钥匙、检查空调",
    "workLabelRequired": "请写明要办什么事",
    "priceAdjust": "工资调整",
    "priceAdjustHint": "这次特殊才勾选；不勾就用房间默认价",
    "clientPriceThisTime": "向委托方收（本单）",
    "staffPayThisTime": "员工工资（本单）",
    "stayTitle": "入住信息",
    "sameDayCheckin": "当天入住",
    "sameDayCheckinHint": "今天退房，下午就有新客人进来，必须当天扫完",
    "guestCount": "入住人数",
    "nights": "入住天数",
    "needsSofaBed": "需要铺沙发床",
    "stayHint": "这几项只是给员工看的干活提示，不参与算钱",
    "notSet": "未填",
    "assignTitle": "分配给",
    "tapStaffHint": "点按选择/取消负责人",
    "sharedCleaning": "共同清扫",
    "tapStaffHintSingle": "只能选 1 人；点其他人会切换",
    "tapStaffHintShared": "已开启共同清扫：可多选",
    "addAssignee": "加人",
    "noStaff": "还没有员工",
    "noStaffHint": "先在「员工管理」里创建账号",
    "unassignedHint": "可以先不选人，回头再派",
    "loadOnDate": "今天已排{count}单",
    "payTitle": "工资分配",
    "payModePercent": "比例",
    "payModeAmount": "金额",
    "poolHint": "房间基础工资 {amount}",
    "splitEvenly": "平分",
    "totalPercent": "合计 {percent}%",
    "totalAmount": "合计 {amount}",
    "overPool": "比房间基础工资多 {amount}",
    "underPool": "比房间基础工资少 {amount}",
    "multiIgnoresOverride": "多人合扫按房间基础工资分配，不使用员工个人调价。",
    "singlePay": "工资 {amount}",
    "note": "备注",
    "notePlaceholder": "例如：客人退房晚，下午2点后再去",
    "lockedTitle": "{name} 已提交完工",
    "lockedHint": "已提交的任务不能改房间和工资，要改请先驳回。",
    "rejectedTitle": "已驳回，等待重新提交",
    "rejectedHint": "可改房间、入住信息和派工，也可重新上传完工照片；保存或再提交后仍为驳回/待审核。",
    "cancelTask": "取消这一单",
    "cancelTitle": "取消这一单？",
    "cancelMessage": "记录会保留下来，但不再出现在日历上。适用于客人取消预订这类情况。",
    "deleteTask": "删除任务",
    "deleteTitle": "删除这一单？",
    "deleteMessage": "这条记录会被彻底删除，无法恢复。建错了才用它——客人取消请用「取消这一单」。",
    "deletePastTitle1": "删除过去日期的安排？",
    "deletePastMessage1": "{date} 是过去的安排。删除后无法恢复。确定继续吗？",
    "deletePastTitle2": "再次确认：删除过去安排",
    "deletePastMessage2": "将彻底删除 {date} · {room} 的清扫登记。请再确认一次。",
    "deletePastNext": "继续删除",
    "deletePastConfirm": "删除",
    "pastNoSchedule": "今天之前的日期也可以新建登记",
    "submitAsOwner": "代员工上报完工",
    "resubmitAsOwner": "重新上报完工",
    "submittedAsOwner": "已代报，进入待审核"
  },
  "review": {
    "rejectReasonLabel": "驳回原因",
    "coworker": "合扫成员",
    "title": "待审核",
    "detailTitle": "审核详情",
    "count": "{count} 单",
    "filterAll": "全部",
    "empty": "没有待审核的单",
    "emptyHint": "员工提交完工后会出现在这里。也可在日历里打开任务点「代员工上报完工」",
    "shared": "合扫",
    "sharedWith": "合扫：{names}",
    "ownerReported": "老板代报",
    "submitted": "提交",
    "totalPay": "应付员工",
    "totalPaySum": "合计应付",
    "clientPrice": "向委托方收",
    "margin": "本单毛利",
    "approve": "确认",
    "reject": "驳回",
    "approveAll": "全部确认",
    "approved": "已确认",
    "approvedAll": "已确认 {count} 单",
    "rejected": "已驳回",
    "rejectTitle": "驳回这一单",
    "rejectHint": "告诉员工哪里要改：",
    "rejectPlaceholder": "例如：浴室那张照片不清楚，请重拍",
    "quickReasons": "常用",
    "reasonBlurry": "照片不清楚",
    "reasonMissingRoom": "少拍了房间",
    "reasonNoReceipt": "收据没传",
    "reasonAmountWrong": "金额对不上",
    "confirmReject": "确认驳回",
    "photos": "完工照片",
    "photosSoon": "照片上传接通后会显示在这里",
    "payBreakdown": "各人应付",
    "staffNote": "备注",
    "noPhotos": "未上传照片",
    "expenses": "费用",
    "paidBy": "由 {name} 垫付",
    "clientCharge": "委托方负担",
    "staffPay": "员工报酬",
    "expenseMargin": "费用利润：{amount}",
    "completionPhotos": "完工照片",
    "noCompletionPhotos": "未上传完工照片",
    "noReceipt": "未上传收据",
    "receiptPhotos": "收据",
    "clientCharges": "向委托方收",
    "staffPays": "付给员工",
    "clientTotal": "委托方合计",
    "staffTotal": "员工合计",
    "saveBilling": "保存金额",
    "billingSaved": "金额已更新",
    "passThroughHint": "烘干费、耗材按实付记为员工垫付，同时向委托方收取"
  },
  "biz": {
    "title": "经营",
    "prevMonth": "上个月",
    "nextMonth": "下个月",
    "allClients": "全部委托方",
    "clientReceivable": "向委托方应收",
    "staffPayable": "实付员工",
    "margin": "毛利",
    "marginRate": "毛利率 {rate}%",
    "counts": "已确认 {approved} 单 ·· 待审 {pending} 单",
    "expenseNote": "其中垫付代收 {amount}（进出相抵，不算收入）",
    "byClient": "按委托方",
    "byStaff": "按员工",
    "clientRow": "应收{receivable}  毛利{margin}",
    "staffTasks": "{count}单",
    "goReview": "去待审核",
    "empty": "这个月还没有已确认的清扫",
    "emptyHint": "在「待审核」里确认之后，金额会出现在这里",
    "payout": {
      "PENDING": "待发放",
      "PAID": "已发放"
    },
    "advanceReceivable": "其中垫付应收 {amount}",
    "payoutPending": "未发放",
    "payoutPaid": "已发放"
  },
  "staffTasks": {
    "empty": "这一天还没有派给你的任务",
    "emptyHint": "老板派工后会出现在这里",
    "sameDay": "当日入住",
    "other": "其他任务",
    "sameDayBadge": "今日有客人入住",
    "status": {
      "PENDING": "待分配",
      "ASSIGNED": "待完工",
      "SUBMITTED": "待审核",
      "APPROVED": "已通过",
      "REJECTED": "已驳回，可重新提交",
      "CANCELLED": "已取消"
    },
    "tapToReport": "点此上报完工",
    "cannotEditHint": "当前状态：{status}。只有「待完工」或「已驳回」才能填写烘干费、照片和凭证。",
    "myPay": "明细",
    "me": "我"
  },
  "staffIncome": {
    "title": "我的收入",
    "empty": "本月还没有收入记录",
    "emptyHint": "老板确认清扫单后，金额会出现在这里",
    "total": "本月合计",
    "cleaning": "清扫",
    "reimbursement": "垫付",
    "special": "特殊报酬",
    "details": "明细",
    "withAdvance": "含垫付",
    "tapReview": "点按查看清扫详情",
    "myPay": "我的明细"
  },
  "taskStatus": {
    "PENDING": "未分配",
    "ASSIGNED": "待办",
    "SUBMITTED": "待确认",
    "APPROVED": "已确认",
    "REJECTED": "已驳回",
    "CANCELLED": "已取消"
  },
  "error": {
    "NETWORK_ERROR": "网络连接失败，请检查网络后重试",
    "TIMEOUT": "请求超时，请重试",
    "AUTH_BAD_CREDENTIALS": "账号或密码不正确",
    "AUTH_CURRENT_PASSWORD_WRONG": "当前密码不正确",
    "AUTH_TOKEN_MISSING": "请先登录",
    "AUTH_TOKEN_INVALID": "登录状态无效，请重新登录",
    "AUTH_TOKEN_EXPIRED": "登录已过期，请重新登录",
    "AUTH_ACCOUNT_DISABLED": "账号已被停用，请联系老板",
    "AUTH_FORBIDDEN": "没有权限执行此操作",
    "AUTH_PASSWORD_CHANGE_REQUIRED": "请先修改密码",
    "TENANT_MISMATCH": "没有权限访问该数据",
    "TENANT_CONTEXT_MISSING": "系统异常，请联系管理员",
    "TENANT_SUSPENDED": "账号所属的组织已停用，请联系管理员",
    "VALIDATION_FAILED": "填写的内容有误，请检查后重试",
    "RESOURCE_NOT_FOUND": "内容不存在或已被删除",
    "USERNAME_ALREADY_EXISTS": "该账号已被占用，请换一个",
    "CLIENT_NAME_ALREADY_EXISTS": "已有同名的委托方，请换一个名称",
    "BUILDING_NAME_ALREADY_EXISTS": "这个委托方下已有同名的楼栋",
    "ROOM_NAME_ALREADY_EXISTS": "这处楼栋里已有相同的房号",
    "RESOURCE_HAS_DEPENDENTS": "下面还有内容，不能删除。可以改用归档",
    "PARENT_ARCHIVED": "上级已归档，请先恢复它",
    "TASK_NOT_EDITABLE": "员工已提交完工，房间和工资不能再改。要改请先驳回",
    "TASK_DATE_IN_PAST": "今天之前的日期也可以登记",
    "SMS_NOT_ENTITLED": "短信发送尚未开通。付费后需由管理员开通",
    "SMS_NOT_CONFIGURED": "短信发送方未配置，请联系管理员",
    "SMS_SEND_FAILED": "短信发送失败",
    "TASK_INVALID_TRANSITION": "这一单的状态已经变了，请刷新后再试",
    "TASK_ROOM_ARCHIVED": "这个房间已停用，不能再建新的清扫任务",
    "TASK_DUPLICATE_ASSIGNEE": "同一个人被加了两次",
    "TASK_ASSIGNEE_INVALID": "这个员工不存在或已停用，请重新选择",
    "TASK_ASSIGNEE_LIMIT_EXCEEDED": "一单最多只能派 5 个人",
    "TASK_PAY_INPUT_INVALID": "工资的比例或金额填得不对，请检查",
    "TASK_REJECT_REASON_REQUIRED": "请写明驳回原因，员工要靠它知道改什么",
    "TASK_WORK_LABEL_REQUIRED": "其它事项请写明要办什么，否则工资单和请求书对不上",
    "INTERNAL_ERROR": "服务器出错了，请稍后再试"
  },
  "entryCheck": {
    "title": "录入检查",
    "open": "检查房间是否已录入",
    "empty": "没有可检查的房间",
    "registered": "已录入",
    "unregistered": "未录入"
  },
  "submitForm": {
    "title": "上报完工",
    "note": "完工备注",
    "completionPhotos": "完工照片",
    "existingPhotos": "已有 {count} 张照片",
    "amount": "金额",
    "description": "说明",
    "paidBy": "垫付人",
    "noPayer": "未指定",
    "receipt": "收据照片",
    "submit": "提交完工",
    "success": "完工信息已提交",
    "types": {
      "DRYER": "烘干费",
      "SUPPLIES": "耗材费",
      "SPECIAL": "特别费用"
    },
    "expenses": "费用明细",
    "paidBySelf": "自己垫付",
    "addPhoto": "添加照片",
    "amountPlaceholder": "0",
    "descriptionPlaceholder": "买了什么（选填）",
    "specialDescPlaceholder": "事由（选填）",
    "notePlaceholder": "需要老板知道的事",
    "addNote": "添加备注",
    "dryerHint": "直接填金额即可；右侧可拍收据",
    "clear": "清除"
  },
  "reviewHistory": {
    "title": "审核历史",
    "open": "历史记录",
    "allStatuses": "全部状态",
    "approved": "已通过",
    "rejected": "已驳回",
    "empty": "本月没有审核记录"
  },
  "statement": {
    "title": "委托方对账单",
    "cleaning": "清扫费",
    "dryer": "烘干费",
    "supplies": "耗材费",
    "special": "特别费用",
    "empty": "本月没有明细",
    "tapReview": "点按查看审核详情",
    "makeInvoice": "做请求书"
  },
  "invoice": {
    "title": "请求书",
    "open": "请求书",
    "profileLink": "请求书抬头",
    "profileTitle": "请求书抬头",
    "profileHint": "印在每张请求书右上角的公司和汇款账户。填一次即可。",
    "needProfile": "还没填公司名和汇款账户，请求书上这两块会是空的。",
    "fillProfile": "去填写",
    "client": "委托方",
    "pickClient": "选择委托方",
    "includeHint": "勾选才会写进这张请求书。烘干费单独一列；耗材费和其它特殊费用跟在当天房间下面单独一行。都不勾就只有清扫金额。",
    "dryer": "烘干费",
    "supplies": "耗材费",
    "special": "其它特殊费用",
    "invoiceDate": "开票日",
    "number": "请求书编号",
    "dueDate": "付款期限",
    "download": "下载 Word",
    "print": "打印",
    "downloaded": "请求书已下载",
    "empty": "这个月没有已审核的清扫，做不出明细",
    "emptyHint": "审核通过之后才会出现在请求书上",
    "legalName": "公司名",
    "registrationNumber": "登录番号",
    "representative": "代表取缔役",
    "postalCode": "邮编",
    "address": "地址",
    "tel": "电话",
    "email": "邮箱",
    "bankName": "银行",
    "bankBranch": "支店",
    "accountType": "账户种类",
    "accountTypePh": "普通",
    "accountNumber": "账号",
    "accountHolder": "户名",
    "saved": "抬头已保存"
  },
  "payroll": {
    "title": "员工工资单",
    "cleaning": "清扫工资",
    "reimbursement": "费用报销",
    "special": "特别报酬",
    "empty": "本月没有工资明细",
    "tapReview": "点按查看审核详情",
    "markPaid": "标记为已发放",
    "markPending": "改回未发放",
    "markedPaid": "已标记为已发放",
    "markedPending": "已改回未发放",
    "paidAt": "已发放 · {date}",
    "confirmNext": "继续",
    "confirmPaidTitle1": "标记为已发放？",
    "confirmPaidMessage1": "将把 {name} 在 {month} 的发放合计 {amount} 标为已发放。请确认这笔钱已经付过。",
    "confirmPaidTitle2": "再次确认：已发放",
    "confirmPaidMessage2": "确定把 {name} 本月合计 {amount} 标为已发放吗？经营页会显示「已发放」。",
    "confirmPaidFinal": "标记为已发放",
    "confirmPendingTitle1": "改回未发放？",
    "confirmPendingMessage1": "将撤销 {name} 在 {month} 的「已发放」标记。",
    "confirmPendingTitle2": "再次确认：改回未发放",
    "confirmPendingMessage2": "确定把 {name} 改回「未发放」吗？仅在误标已发放时使用。",
    "confirmPendingFinal": "改回未发放"
  },
  "sms": {
    "title": "短信提醒",
    "settingsLink": "短信提醒设置",
    "phone": "接收手机号",
    "phoneHint": "请使用国际格式",
    "morning": "早间提醒",
    "morningHint": "适合发送今日清扫安排",
    "afternoon": "下午提醒",
    "afternoonHint": "适合发送明日安排，或今日清扫成果",
    "contentPick": "这条短信的内容",
    "kindToday": "今日清扫安排",
    "kindTodayHint": "民宿、房间、负责人、当日入住",
    "kindTomorrow": "明日清扫安排",
    "kindTomorrowHint": "明日民宿、房间、负责人、当日入住",
    "kindResults": "今日清扫成果",
    "kindResultsHint": "完成数、收入、支出、是否有待审核",
    "maxRooms": "短信最多列出房间数",
    "maxRoomsHint": "超出部分写成「另有 N 间」，控制字数与费用",
    "locale": "短信语言",
    "sendTest": "发送测试短信",
    "testMorning": "测试早间内容",
    "testAfternoon": "测试下午内容",
    "testSent": "测试短信已发送",
    "entitlementOff": "短信发送尚未开通。设置仍可保存。付费后需由管理员开通。",
    "providerOff": "服务器未配置发送方，请联系管理员。",
    "entitlementOn": "短信发送已开通",
    "trialHint": "若 Twilio 试用账号出现模板限制（572006）：请升级账号或配置 TWILIO_CONTENT_SID。接收号码须为已验证号码。"
  },
  "adminOrgs": {
    "nav": "租户管理",
    "title": "组织管理",
    "subtitle": "开通主体、记录微信月费、管理短信权限。支付 API 预留中。",
    "createTitle": "开通新组织",
    "orgName": "组织名称",
    "loginCode": "登录代码",
    "ownerUsername": "老板账号",
    "ownerPassword": "初始密码",
    "ownerDisplayName": "老板姓名",
    "create": "创建组织",
    "created": "组织已创建",
    "updated": "已更新",
    "active": "启用中",
    "inactive": "已停用",
    "suspend": "停止登录",
    "activate": "恢复登录",
    "smsOn": "短信已开通",
    "smsOff": "短信未开通",
    "smsEnable": "开通短信",
    "smsDisable": "停止短信",
    "smsUpdated": "短信权限已更新",
    "extendBox": "微信到账后：开通月费（用下方按钮生效）",
    "extendHint": "填好月数/金额/备注后，再点对应租户的「开通月费」。",
    "months": "月数",
    "amountYen": "金额（日元）",
    "note": "备注",
    "notePh": "微信转账单号",
    "extendAction": "开通月费",
    "extended": "已开通月费期限",
    "showLedger": "计费记录",
    "hideLedger": "收起记录",
    "ledgerEmpty": "暂无记录",
    "billingNote": "备注",
    "voidAction": "撤销",
    "voided": "已撤销月费开通",
    "voidedBadge": "已撤销",
    "voidNext": "继续",
    "voidTitle1": "撤销这笔月费开通？",
    "voidMessage1": "将撤销 {org} 的 {period}（{amount}）。到期日也会重新计算。",
    "voidTitle2": "再次确认：撤销月费开通",
    "voidMessage2": "确定撤销 {org} 的这条计费记录吗？撤销后历史中会留下撤销记录。",
    "voidFinal": "撤销",
    "resetPassword": "重置密码",
    "resetPasswordTitle": "重置老板密码",
    "resetPasswordMessage": "将把 {name}（{username}）的登录密码改成你输入的内容。",
    "resetPasswordPlaceholder": "新密码，至少 8 位",
    "resetPasswordConfirm": "确认重置",
    "resetPasswordSuccess": "已重置 {name} 的密码",
    "resetPasswordNeedOwner": "该组织还没有老板账号",
    "kind": {
      "MONTHLY_FEE": "开通月费",
      "MONTHLY_FEE_VOID": "撤销月费",
      "SMS_ENABLE": "开通短信",
      "SMS_DISABLE": "停止短信",
      "ADJUSTMENT": "调整",
      "NOTE": "备注"
    },
    "sub": {
      "NONE": "未计费",
      "TRIAL": "试用",
      "ACTIVE": "计费中",
      "EXPIRED": "已过期"
    }
  },
  "ownerMonth": {
    "title": "本月总览",
    "open": "本月总览",
    "total": "全部任务",
    "pending": "待分配",
    "assigned": "已分配",
    "submitted": "待审核",
    "approved": "已通过",
    "empty": "这个月还没有清扫任务",
    "emptyHint": "录入后会按日期显示在这里",
    "openDay": "看这一天",
    "byDate": "按日期",
    "byBuilding": "按楼栋",
    "byBuildingHint": "按楼栋汇总本月清扫",
    "byStaff": "按员工",
    "byStaffHint": "合扫会在每位员工下重复显示",
    "unassigned": "未分配",
    "unknownBuilding": "未知楼栋",
    "staffTaskCount": "{count} 单",
    "staffSameDay": "当日入住 {count}",
    "staffPay": "本月明细 {amount}",
    "exportExcel": "Excel",
    "exportStaffPayExcel": "员工工资",
    "excelExported": "已导出 Excel",
    "staffPayExcelExported": "已导出员工工资 Excel",
    "staffPayExcelFilename": "员工工资_{year}年{month}月.xlsx",
    "staffPayExcelTitle": "{name} · {year}年{month}月工资",
    "staffPayExcelGrand": "本月应付合计 {amount}",
    "staffPayExcelBuilding": "{name}",
    "staffPayExcelSubtotal": "民宿小计",
    "staffPayExcelTotal": "员工合计",
    "staffPayExcelEmpty": "本月还没有已确认的工资明细（请先在待审核里确认）",
    "staffPayExcelEmptySheet": "无数据",
    "excelSheet": "{year}年{month}月清扫",
    "excelFilename": "清扫一览_{year}年{month}月.xlsx",
    "excelBuildingTitle": "{name}",
    "excelYes": "是",
    "excelNo": "否",
    "excelNoBuildings": "还没有楼栋",
    "excelShared": "多人合扫",
    "excelWorkKindCleaning": "清扫",
    "excelWorkKindOther": "其它事项",
    "staffPayExcelCol": {
      "date": "日期",
      "room": "房号",
      "workKind": "类型",
      "workLabel": "其它事项说明",
      "cleaningPay": "清扫工资",
      "dryer": "烘干费",
      "supplies": "耗材费",
      "special": "特别费用",
      "specialReason": "特别费用原由",
      "rowTotal": "小计",
      "note": "备注"
    },
    "excelCol": {
      "date": "日期",
      "weekday": "星期",
      "staff": "清扫负责人",
      "room": "房号",
      "sameDay": "当日入住",
      "guests": "入住人数",
      "nights": "入住天数",
      "workKind": "类型",
      "workLabel": "其它事项说明",
      "clientPay": "委托方收款",
      "staffPay": "员工工资",
      "dryer": "烘干费",
      "supplies": "耗材费",
      "special": "特别费用",
      "specialReason": "特别费用原由",
      "note": "备注"
    }
  },
  "quickEntry": {
    "title": "轻松录入",
    "open": "快速录入",
    "empty": "没有可录入的楼栋和房间",
    "registered": "已录入",
    "sameDay": "当天入住",
    "submit": "录入 {count} 间",
    "success": "已录入 {created} 间，跳过 {skipped} 间",
    "keepHint": "切换日期或楼栋时，已选项会保留",
    "selectAll": "全选本栋",
    "clearBuilding": "清空本栋",
    "tapToPick": "点按选择",
    "picked": "已选",
    "submitAll": "保存所选 {count} 间",
    "otherDatesPending": "其他日期还有 {count} 间未保存",
    "unregister": "撤销",
    "registeredTapCancel": "已登记 · 可撤销",
    "registeredLocked": "已提交/已确认，此处不可撤销",
    "cannotUnregister": "已提交或已确认，请到日历操作",
    "unregisterTitle": "撤销这条登记？",
    "unregisterMessage": "将删除 {room} 当天的清扫登记（仅未提交时可撤）。",
    "unregisterConfirm": "撤销",
    "unregisterPastTitle1": "删除过去日期的安排？",
    "unregisterPastMessage1": "{date} · {room} 是过去的安排。删除后无法恢复。确定继续吗？",
    "unregisterPastTitle2": "再次确认：删除过去安排",
    "unregisterPastMessage2": "将彻底删除 {date} · {room} 的清扫登记。请再确认一次。",
    "unregisterPastNext": "继续删除",
    "unregistered": "已撤销 {room}",
    "pastHint": "删除过去日期的安排需确认两次",
    "pastNoSchedule": "今天之前的日期也可以新建登记",
    "pastRoomHint": "可新建"
  },
  "staffMonth": {
    "title": "本月任务",
    "open": "本月总览",
    "total": "本月合计",
    "count": "{count} 单",
    "todo": "待完工",
    "pending": "待审核",
    "done": "已通过",
    "paySum": "明细合计",
    "empty": "这个月还没有派给你的任务",
    "emptyHint": "老板派工后会出现在这里",
    "openDay": "看这一天"
  }
}
